import Vue from "vue";
import * as filters from "@/utils/filters";

Object.keys(filters).forEach(filterFn => {
  Vue.filter(filterFn, filters[filterFn]);
});